import { FormComponentPropsBase } from '@unistocks/components/form/model';
import { PropsWithChildren } from 'react';
import { FieldValues } from 'react-hook-form';

export const FORMFIELD_COTNAIER_NAME = 'FormFieldContainer';

type FormFieldName<T extends FieldValues = FieldValues> = Partial<
  Pick<FormComponentPropsBase<T>, 'name'>
>;

/**
 * Marks a subtree as belonging to @param name so multi-step validation includes it.
 * Rendering is transparent: fields bind to the form through the form context.
 */
export function FormFieldContainer<T extends FieldValues = FieldValues>({
  children
}: PropsWithChildren<FormFieldName<T>>) {
  return <>{children}</>;
}

FormFieldContainer.displayName = FORMFIELD_COTNAIER_NAME;
